import UserModel from '../../../../UserModel';
import { createRenderWithWrappers } from '../../../../utils/composeRenderWrappers';
import withProductsTabsWrapper from '../../../../setup/modules/products/components/withProductsTabsWrapper';
import { withCustomProductDetailsHoc } from './HOCs/CustomProductDetailsHoc';

const hasAnyPermissions = (permissions) => UserModel.getCurrentUser().hasAnyPermissions(permissions);

export default {
    name: 'productDetailsPage',
    before: [],
    after: [],
    setup: (app) => {
        const pageName = 'productDetailsOverview';
        const pageRoute = app.routes.getItem(pageName);
        if (pageRoute) {
            const pageRouteProps = pageRoute.props;

            pageRoute.props = (state) => ({
                ...pageRouteProps(state),
                permissions: {
                    canActivate: hasAnyPermissions('products.activate'),
                    canDeactivate: hasAnyPermissions('products.deactivate'),
                    canEdit: hasAnyPermissions('products.update'),
                },
            });

            pageRoute.render = createRenderWithWrappers([
                withProductsTabsWrapper(app),
                withCustomProductDetailsHoc(app),
            ]);
            app.routes.changeItem(pageName, pageRoute);
        }
    },
};
